<script>
    export default {
        name: 'YcHeader',
        mounted () {
            window.renderHeaderAndFooter && window.renderHeaderAndFooter('.with-yc-header', false, true, true);
        }
    };
</script>

<template>
    <div class="with-yc-header"></div>
</template>

<style scoped lang="less">

</style>
